export const DOCUMENT_TYPE_LIST_REQUEST = 'DOCUMENT_TYPE_LIST_REQUEST'
export const DOCUMENT_TYPE_LIST_SUCCESS = 'DOCUMENT_TYPE_LIST_SUCCESS'
export const DOCUMENT_TYPE_LIST_FAIL = 'DOCUMENT_TYPE_LIST_FAIL'
